import React, { Component } from 'react';
import Seccion1 from '../components/Quiero_Asociarme/Seccion1';
import MensajeF from '../components/Mensaje_Flotante/MensajeF';
import Seccion2 from '../components/Quiero_Asociarme/Seccion2';
import Footer from '../components/Principal/Footer';
import Header from '../components/Principal/Header';

class QuieroAsociarme extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadpage: false
        };
    }
    componentDidMount() {
        setTimeout(() => {
            this.setState({
                loadpage: true
            })
        }, 0.1)
    }
    render() {
        return (
            <React.Fragment>
                <Header id={2} />
                <MensajeF />
                {this.state.loadpage ? (
                    <div>
                        <Seccion1 />
                        <Seccion2 />
                    </div>
                ) : (<React.Fragment></React.Fragment>)}
                <Footer />
            </React.Fragment>
        );
    }
}

export default QuieroAsociarme;